import React from 'react';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Compare Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Compare algorithm-generated multi-vehicle routes with manually designed routes to evaluate efficiency, vehicle utilization, and identify optimization opportunities in VRP solutions.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>Multi-vehicle solution created in Auto Find Path Mode</li>
            <li>Multi-vehicle solution created in Custom Path Mode</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Create Both Solutions:</strong>
              <ul>
                <li>Go to Auto Find Path Mode and generate optimal routes</li>
                <li>Go to Custom Path Mode and design your own vehicle routes</li>
                <li>Both solutions automatically saved</li>
              </ul>
            </li>
            <li><strong>View Comparison:</strong>
              <ul>
                <li>Switch to Compare Mode</li>
                <li>Both multi-vehicle solutions displayed side by side</li>
                <li>All routes shown on map with color coding</li>
              </ul>
            </li>
            <li><strong>Review Solution Information:</strong>
              <ul>
                <li><strong>Auto Solution:</strong> Algorithm-generated routes
                  <ul>
                    <li>Total distance</li>
                    <li>Number of vehicles used</li>
                    <li>Individual vehicle routes</li>
                  </ul>
                </li>
                <li><strong>Custom Solution:</strong> Manually designed routes
                  <ul>
                    <li>Total distance</li>
                    <li>Number of vehicles used</li>
                    <li>Individual vehicle routes</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li><strong>Analyze Comparison Results:</strong>
              <ul>
                <li><strong>Distance Difference:</strong> Total km saved or added</li>
                <li><strong>Vehicle Count Difference:</strong> Resource utilization comparison</li>
                <li><strong>Efficiency Rating:</strong> Which solution performs better</li>
              </ul>
            </li>
            <li><strong>Detailed Analysis (Optional):</strong>
              <ul>
                <li>Click "Show Detailed Comparison"</li>
                <li>Vehicle-by-vehicle breakdown</li>
                <li>Route distance comparisons</li>
                <li>Optimization suggestions</li>
              </ul>
            </li>
          </ol>

          <p><strong>Comparison Metrics:</strong></p>
          <ul>
            <li><strong>Total Distance:</strong> Sum of all vehicle routes in kilometers</li>
            <li><strong>Vehicle Count:</strong> Number of vehicles deployed</li>
            <li><strong>Distance Difference:</strong> Absolute difference in km</li>
            <li><strong>Percentage Difference:</strong> Relative efficiency gap</li>
            <li><strong>Vehicle Utilization:</strong> How efficiently vehicles are used</li>
          </ul>

          <p><strong>Interpretation:</strong></p>
          <ul>
            <li><strong>"Saved X km":</strong> Custom solution is more efficient</li>
            <li><strong>"Extra X km":</strong> Auto solution is more efficient</li>
            <li><strong>Vehicle Count:</strong> Fewer vehicles usually better (lower operational costs)</li>
            <li><strong>Trade-offs:</strong> More vehicles may reduce distance but increase costs</li>
          </ul>

          <p><strong>Learning from Comparison:</strong></p>
          <ul>
            <li><strong>Clustering Patterns:</strong> How customers are grouped geographically</li>
            <li><strong>Route Balance:</strong> How workload is distributed among vehicles</li>
            <li><strong>Optimization Techniques:</strong> Learn from algorithm's customer assignments</li>
            <li><strong>Capacity Utilization:</strong> How well vehicle capacity is used</li>
          </ul>

          <p><strong>Use Cases:</strong></p>
          <ul>
            <li>Validate algorithm solutions against real-world constraints</li>
            <li>Learn multi-vehicle optimization principles</li>
            <li>Identify inefficiencies in manual route planning</li>
            <li>Balance between distance minimization and vehicle count</li>
            <li>Educational tool for understanding VRP algorithms</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Both solutions must be complete before comparison works</li>
            <li>Consider both distance and vehicle count in evaluation</li>
            <li>Use detailed comparison to understand specific route differences</li>
            <li>Algorithm may use fewer vehicles more efficiently</li>
            <li>Manual solutions can incorporate practical constraints algorithms miss</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 